import { useState } from "react";
import { Button, Image } from "../../../atom";

interface CardFeatureProps {
  title: string;
  category: string;
  imageUrl: string;
}

const CardFeature = ({ title, category, imageUrl }: CardFeatureProps) => {
  const [hoverState, setHoverState] = useState<Boolean>(false);
  return (
    <>
      <div
        className={`flex-shrink-0 mr-11 lg:mr-5 relative rounded-2xl border-4 box-border duration-300 transition-all ease-in-out ${
          hoverState ? " border-black scale-105" : "border-white scale-100"
        }`}
        onMouseEnter={() => setHoverState(true)}
        onMouseLeave={() => setHoverState(false)}
      >
        <Button type="link" href="/game/sdasdk" className="rounded-xl">
          <div
            className={`${
              hoverState && "scale-90"
            } duration-500 transition-all ease-in-out overflow-hidden rounded-2xl`}
          >
            <Image type="imageFeature" url={imageUrl} alt="image thumbnail" />
          </div>
          <div
            className={`${
              hoverState ? "opacity-100" : "opacity-5"
            } duration-300 transition-opacity ease-in-out absolute top-0 p-2 overflow-hidden w-full h-full`}
          >
            <div className="flex flex-col justify-end items-end backdrop-blur-lg bg-white/5 h-full pb-10 px-5 rounded-2xl">
              <svg
                width="54"
                height="36"
                viewBox="0 0 54 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`${
                  hoverState ? "translate-y-0" : "-translate-y-10"
                } mx-auto transition-transform duration-300`}
              >
                <path
                  d="M48.8309 6.33404C41.7479 -5.30296 31.0779 2.79304 31.0779 2.79304C30.3859 3.31604 29.1099 3.74604 28.2429 3.74804L25.3849 3.75004C24.5179 3.75104 23.2419 3.32104 22.5509 2.79804C22.5509 2.79804 11.8799 -5.29996 4.79595 6.33704C-2.28605 17.97 0.567947 30.639 0.567947 30.639C1.06795 33.741 2.71595 35.811 5.82595 35.551C8.92695 35.292 15.6579 27.197 15.6579 27.197C16.2139 26.53 17.3789 25.985 18.2439 25.985L35.3779 25.982C36.2439 25.982 37.4079 26.527 37.9629 27.194C37.9629 27.194 44.6949 35.289 47.8009 35.548C50.9069 35.808 52.5589 33.736 53.0559 30.636C53.0549 30.636 55.9139 17.969 48.8309 6.33404ZM20.3739 15.806H16.6999V19.347C16.6999 19.347 15.9219 19.941 14.7179 19.926C13.5159 19.908 12.9719 19.278 12.9719 19.278V15.807H9.50195C9.50195 15.807 9.06895 15.363 8.95295 14.194C8.83895 13.025 9.43195 12.08 9.43195 12.08H13.1069V8.40604C13.1069 8.40604 13.8629 8.00104 14.9499 8.03204C16.0379 8.06604 16.8349 8.47504 16.8349 8.47504L16.8199 12.079H20.2899C20.2899 12.079 20.8959 12.857 20.9459 13.797C20.9959 14.738 20.3739 15.806 20.3739 15.806ZM37.2259 19.842C35.6169 19.842 34.3199 18.541 34.3199 16.934C34.3199 15.324 35.6169 14.026 37.2259 14.026C38.8279 14.026 40.1349 15.324 40.1349 16.934C40.1349 18.542 38.8279 19.842 37.2259 19.842ZM37.2259 11.841C35.6169 11.841 34.3199 10.541 34.3199 8.93404C34.3199 7.32404 35.6169 6.02604 37.2259 6.02604C38.8279 6.02604 40.1349 7.32404 40.1349 8.93404C40.1349 10.542 38.8279 11.841 37.2259 11.841ZM44.4679 16.136C42.8589 16.136 41.5619 14.836 41.5619 13.228C41.5619 11.619 42.8589 10.32 44.4679 10.32C46.0699 10.32 47.3769 11.619 47.3769 13.228C47.3769 14.836 46.0699 16.136 44.4679 16.136Z"
                  fill="white"
                />
              </svg>
              <div
                className={`${
                  hoverState ? "translate-y-0" : "translate-y-10"
                } mx-auto transition-transform duration-300 mt-10`}
              >
                <h1 className="text-white font-semibold text-2xl">{title}</h1>
                <span className="text-white font-light text-lg">
                  {category}
                </span>
              </div>
            </div>
          </div>
        </Button>
      </div>
    </>
  );
};
export default CardFeature;
